<template>
	<div>
		<el-tag type="info" disable-transitions :closable="employee ? true : false" @click="checkEmployeeShow = true" @close="clearEmployee" style="cursor: pointer;">
			<span v-if="employee">{{ employee.name }}({{ employee.officeid }})</span>
			<span v-else>
				点击选择
				<i class="el-icon-arrow-down"></i>
			</span>
		</el-tag>
		<check-employee :show="checkEmployeeShow" @close="checkEmployeeShow = false" @change="changeEmployee" type="single"></check-employee>
	</div>
</template>

<script>
import checkEmployee from '@/components/check-employee.vue';
export default {
	components: { checkEmployee },
	name: 'form-item-employee',
	model: {
		prop: 'id',
		event: 'changeId'
	},
	props: {
		id: {
			type: String,
			default: () => {
				return '';
			}
		},
		config: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			checkEmployeeShow: false,
			configData: {},
			employee: null
		};
	},
	beforecreate: function() {},
	created: function() {},
	mounted() {
		this.configData = this.config;
	},
	updated: function() {},
	methods: {
		changeEmployee(e) {
			console.log(e);
			this.employee = e.data;
			this.$emit('change', e.data);
			this.$emit('changeId', e.data.id);
		},
		clearEmployee() {
			this.employee = null;
			this.$emit('change', null);
			this.$emit('changeId', '');
		}
	},
	watch: {}
};
</script>

<style></style>
